
import { makeDefaultFailedContainer } from 'components/container'
import EndUserAttributesCard from 'components/customer/EndUserAttributesCard'
import TimeLine from 'components/customer/TimeLine'
import Inputs from 'components/customer/Inputs'
import Header from 'components/nav/Header'
import HeaderBackButton from 'components/nav/Header/HeaderBackButton'
import TitleCard from 'components/customer/TitleCard'
import SegmentsCard from 'components/customer/SegmentsCard'

import 'styles/components/customer/CustomerInfo.styl'

const EndUserInfo = React.createClass({
  displayName: 'EndUserInfo',

  renderLeftNav() {
    return (
      <HeaderBackButton
        target="_self"
        text="All Contacts"
        to="/contacts"
      />
    )
  },

  render() {
    return (
      <Header title="All Contacts" leftNav={this.renderLeftNav()} showClose={true}>
        <div className="Page">
          <div className="CustomerInfo EndUserInfo">
            <div className="left-section">
              <TitleCard endUser={this.props.endUser} showTooltip={true} />
              <EndUserAttributesCard endUser={this.props.endUser} />
              <SegmentsCard endUserId={this.props.endUser.id} />
            </div>
            <div className="right-section flex-column">
              <Inputs endUser={this.props.endUser} />
              <div className="profile-content-wrapper">
                <TimeLine endUser={this.props.endUser} />
              </div>
            </div>
          </div>
        </div>
      </Header>
    )
  }
})

const Wrapper = makeDefaultFailedContainer(EndUserInfo, {
  listenTo: ['stores.EndUserStore'],

  getEndUserId() {
    return this.props.endUserId || this.props.params.endUserId
  },

  fetch: {
    endUser() {
      return this.app.stores.EndUserStore.getOrFetchEndUser(this.getEndUserId())
    },
  }
})

export default Wrapper



// WEBPACK FOOTER //
// ./src/scripts/components/customer/EndUserInfo.js